module.exports = __webpack_public_path__ + "img/pic02.add7a43f.png";